// View script placeholder